import { gql } from 'graphql-request'

export const businessRefundSettingsThresholdsFragment = gql`
  fragment businessRefundSettingsThresholdType on businessRefundSettingsThreshold {
    id
    hours
    percentage
  }
`

export const businessRefundSettingsPolicyFragment = gql`
  ${businessRefundSettingsThresholdsFragment}
  fragment businessRefundSettingsPolicyType on businessRefundSettingsPolicy {
    id
    type
    isRefundAllowed
    thresholds {
      ...businessRefundSettingsThresholdType
    }
    updatedAt
  }
`

export const businessRefundSettingsFragment = gql`
  ${businessRefundSettingsPolicyFragment}
  fragment businessRefundSettingsType on businessRefundSettings {
    id
    isActive
    refundSettingsPolicies {
      ...businessRefundSettingsPolicyType
    }
  }
`
